import { View, Log, Utils } from '../vendor/kerneljs';
import { default as DatePickerPikaday } from '../components/datepicker-pikaday';

function handleFormsSelectField(elem) {
    if (Utils.hasClass(elem, 'custom-select')) {
        return;
    } else if (Utils.hasClass(elem, 'form__field--select--choices')) {
        if (Utils.hasClass(elem, 'is-custom')) {
            return;
        } else if (Utils.hasClass(elem, 'form__field--select--choices--template')) {
            new SelectChoicesTemplate({ el: elem });
        } else {
            new SelectChoices({ el: elem });
        }
    } else {
        new Select({ el: elem });
    }
}

function handleFormsDateField(elem) {
    if (!Utils.hasClass(elem, 'is-custom')) {
        new DatePickerPikaday({ el: elem, nativeMobile: false });
    }
}

const Forms = View.extend({

	initialize: function () {
		console.log("Forms")

		Utils.each(Utils.find(this.el, '.form__field'), function (elem) { //if a whole form is passed
			if (Utils.hasClass(elem, '.is-bound')) return;

			if (Utils.hasClass(elem, 'form__field--select')) {
				handleFormsSelectField(elem);
			} else if (Utils.hasClass(elem, 'form__field--radio')) {
				new Radio({ el: elem });
			} else if (Utils.hasClass(elem, 'form__field--textarea')) {
				new Textarea({ el: elem });
			} else if (Utils.hasClass(elem, 'form__field--checkbox')) {
				new CheckBox({ el: elem });
			} else if (Utils.hasClass(elem, 'form__field--text')) {
				new Text({ el: elem });
			} else if (Utils.hasClass(elem, 'form__field--file')) {
				new FileUpload({ el: elem });
			} else if (Utils.hasClass(elem, 'form__field--date')) {
				handleFormsDateField(elem);
			}
		});
	}
});

//Select
const Select = View.extend({
	currentValue: 'default',
	events: {
		'focus .form__item': 'onFocus',
		'blur .form__item': 'onBlur',
		'change .form__item': 'onChange',
		'select .form__item': 'onSelect'
	},
	initialize: function () {
		console.log("Select")
		this.addClass('is-bound');
		this.formItem = this.find('.form__item');
		if (!this.hasClass('is-filled')) {
			this.formItem.selectedIndex = -1;
		}
	},
	onFocus: function () {
		if (this.hasClass('is-disabled')) return;
		this.addClass('has-focus');
		this.addClass('is-filled');
	},
	onChange: function () {
		this.formItem.blur();
		this.onBlur();
	},
	onSelect: function () {
		this.formItem.blur();
		this.onBlur();
	},
	onBlur: function () {
		this.removeClass('has-focus');
		if (this.formItem.selectedIndex >= 0) {
			this.currentValue = this.formItem.options[this.formItem.selectedIndex].value;
		}
		else {
			this.removeClass('is-filled');
		}

		if (this.currentValue === 'default') {
			this.removeClass('is-filled');
		}
	}
});

const SelectChoices = View.extend({
	events: {
	},
	initialize: function () {
		console.log("SelectChoices")
		this.selectElement = this.find('.js--select');

		if (!(this.selectElement instanceof HTMLElement)) {
			throw new Error('.js--select element not found.');
		}
		this.choices = new Choices(this.selectElement, {
			searchEnabled: false,
			itemSelectText: '',
			shouldSort: false
		});

		setTimeout(function () {
			Utils.addClass(this.find('.choices__list--single'), 'is-ready');
		}.bind(this), 400);

	}
});




const SelectChoicesTemplate = View.extend({

	events: {

	},

	initialize: function () {
		console.log("SelectChoicesTemplate")
		this.selectElement = this.find('.js--select');

		if (!(this.selectElement instanceof HTMLElement)) {
			throw new Error('.js--select element not found.');
		}


		let assetType = '';
		if (this.el.getAttribute('data-type')) {
			assetType = this.el.getAttribute('data-type');
		}
		else {
			throw new Error('Choices needs type, either data-type="images" or data-type="colors".');
		}

		let assetList = [];
		let options = this.find('option');

		Utils.each(options, function (elem) {
			assetList.push(elem.getAttribute('data-asset'));
		});
		if (assetList.length === 0) {
			throw new Error('No assets found for options. Data is incomplete.');
		}


		if (this.selectElement instanceof HTMLElement) {
			new Choices(this.selectElement, {
				searchEnabled: false,
				itemSelectText: '',
				placeholderValue: 'Søg…',
				shouldSort: false,
				callbackOnCreateTemplates: function (strToEl) {

					let classNames = this.config.classNames;
					let itemSelectText = this.config.itemSelectText;


					return {

						item: function (data) {
							let extraSpan = '<span class="choices__item__type">';
							if (assetType === 'images') {
								extraSpan += '<img class="choices__item__type--image" src="' + assetList[data.choiceId - 1] + '"/>';
							} else if (assetType === 'colors') {
								extraSpan += '<span class="choices__item__type--color" style="background-color:' + assetList[data.choiceId - 1] + ';"/>';
							}
							extraSpan += '</span>'
							return strToEl(`
							<div
								class="${String(classNames.item)} ${String(data.highlighted ? classNames.highlightedState : classNames.itemSelectable)}"
								data-item
								data-id="${ String(data.id)}"
								data-value="${ String(data.value)}"
								${String(data.active ? 'aria-selected="true"' : '')}
								${ String(data.disabled ? 'aria-disabled="true"' : '')}
								>
								${ extraSpan + String(data.label)}
							</div>
							`);
						},

						choice: function (data) {
							let extraSpan = '<span class="choices__item__type">';
							if (assetType === 'images') {
								extraSpan += '<img class="choices__item__type--image" src="' + assetList[data.id - 1] + '"/>';
							} else if (assetType === 'colors') {
								extraSpan += '<span class="choices__item__type--color" style="background-color:' + assetList[data.id - 1] + ';"/>';
							}
							extraSpan += '</span>'
							return strToEl(`
							<div
								class="${ String(classNames.item)} ${String(classNames.itemChoice)} ${String(data.disabled ? classNames.itemDisabled : classNames.itemSelectable)}"
								data-select-text="${ String(itemSelectText)}"
								data-choice
								${String(data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable')}
								data-id="${String(data.id)}"
								data-value="${ String(data.value)}"
								${String(data.groupId > 0 ? 'role="treeitem"' : 'role="option"')}
								>
								${ extraSpan + String(data.label)}
							</div>
							`);
						},
					};
				}
			});

			setTimeout(function () {
				Utils.addClass(this.find('.choices__list--single'), 'is-ready');
			}.bind(this), 400);
		}
	}
});


//Radio
const Radio = View.extend({
	events: {
		'click .form__item': 'onClick'
	},
	initialize: function () {
		console.log("Radio")
		this.addClass('is-bound');
		this.formItem = this.find('.form__item');
		if (this.formItem.checked || this.hasClass('is-checked')) {
			this.formItem.setAttribute('checked', 'checked');
			this.formItem.checked = 'checked';
		}
		this.eventEmitter.on('radio:change', this.onChange.bind(this));
	},
	onClick: function (e) {
		this.eventEmitter.emit('radio:change', e, this.formItem.name);
	},
	onChange: function (e, name) {
		if (this.formItem.name === name) {
			this.toggleClass('is-checked', this.formItem.checked);
			if (this.formItem.checked) this.formItem.setAttribute('checked', 'checked');
			else this.formItem.removeAttribute('checked');
		}
	}
});


//CheckBox
const CheckBox = View.extend({
	events: {
		'click .form__item': 'onClick'
	},
	initialize: function () {
		console.log("CheckBox")
		this.addClass('is-bound');
	},
	onClick: function (e) {
		// do nothing
	}
});


//Textarea
const Textarea = View.extend({
	events: {
		'focus .form__item': 'onFocus',
		'blur .form__item': 'onBlur'
	},
	initialize: function () {
		console.log("Textarea")
		this.addClass('is-bound');
		this.formItem = this.find('.form__item');
		setTimeout(function () {
			if (this.formItem.value.length > 0) this.addClass('is-filled');
		}.bind(this), 10);
	},
	onFocus: function () {
		if (this.hasClass('is-disabled')) return;
		this.addClass('has-focus');
		this.addClass('is-filled');
	},
	onBlur: function () {
		this.removeClass('has-focus');
		if (this.formItem.value.length === 0) this.removeClass('is-filled');
	}
});

//Text
const Text = View.extend({
	events: {
		'focus .form__item': 'onFocus',
		'blur .form__item': 'onBlur'
	},
	initialize: function () {
		console.log("Text")
		this.addClass('is-bound');
		this.formItem = this.find('.form__item');

		this.clearButton = this.hasClass('form__field--text-clear') ? this.find('button') : null;

		if ((this.clearButton instanceof HTMLElement)) {
			Utils.on(this.clearButton, 'click', this.onClear.bind(this));
			Utils.on(this.formItem, 'keyup', this.onChange.bind(this));
			Utils.on(this.formItem, 'keypress', this.onChange.bind(this));
			Utils.on(this.formItem, 'change', this.onChange.bind(this));
		}

		if (this.formItem.hasAttribute('maxlength')) {
			Utils.on(this.formItem, 'keyup', this.onChange.bind(this));
		}

		if (this.hasClass('is-number')) {
			Utils.on(this.formItem, 'input', this.filterNumbers.bind(this));
		}

		setTimeout(function () {
			if (this.formItem.value.length > 0) this.addClass('is-filled');
		}.bind(this), 10);
	},
	onFocus: function () {
		if (this.hasClass('is-disabled')) return;
		this.addClass('has-focus');
		this.addClass('is-filled');
	},
	onBlur: function () {
		this.removeClass('has-focus');
		if (this.formItem.value.length === 0 && !this.formItem.getAttribute('placeholder')) this.removeClass('is-filled');
	},
	onChange: function (event) {
		Log.db("onChange")
		if (this.clearButton instanceof HTMLElement) {
			Utils.addClass(this.clearButton, 'is-active');
		}
		this.changeFocusIfFilled(event)
	},
	onClear: function () {
		Utils.removeClass(this.clearButton, 'is-active');
		this.formItem.value = '';
		this.formItem.focus();
	},
	filterNumbers: function () {
		// Use numbers only pattern, from 0 to 9
		const nonNumber = /\D/gi;
		// This removes any other character but numbers as entered by user
		this.formItem.value = this.formItem.value.replace(nonNumber, "");
	},
	changeFocusIfFilled: function (event) {
		// keyCode 9  = tab,
		// keyCode 16 = shift
		// keyCode 8  = backspace
		if (event.keyCode === 9 || event.keyCode === 16) {
			return;
		}

		// returns el with the passed class
		const findParentWithClass = (el, selector) => {
			const parent = el.parentElement;
			if (parent.tagName === 'BODY') return;
			return parent.classList.contains(selector) ? parent : findParentWithClass(parent, selector);
		}

		const form = findParentWithClass(this.formItem, 'form');
		const allInputs = [...form.querySelectorAll('.form__item')];
		const thisInputIndex = allInputs.indexOf(this.formItem);

		const maxLength = (this.formItem.attributes["maxlength"] && parseInt(this.formItem.attributes["maxlength"].value, 10)) || 9999
		const curLength = this.formItem.value.length;

		if ((curLength >= maxLength) && (thisInputIndex !== allInputs.length - 1)) {
			allInputs[thisInputIndex + 1].focus();
		}
		else if (curLength === 0 && thisInputIndex !== 0 && event.keyCode === 8) {
			allInputs[thisInputIndex - 1].focus();
		}
	}
});


//FileUpload
const FileUpload = View.extend({
	events: {
		'click .js--get-list': 'getFileList',
		'change .form__item': 'changeHandler',
		'dragover .form__label': 'dragEnterHandler',
		'dragenter .form__label': 'dragEnterHandler',
		'dragleave .form__label': 'dragExitHandler',
		'dragexit .form__label': 'dragExitHandler',
		'drop .form__label': 'dropHandler'
	},
	initialize: function () {
		console.log("FileUpload")
		this.addClass('is-bound');
		this.formItem = this.find('.form__item');
		this.multipleCaption = this.formItem.getAttribute('data-multiplecaption');
		this.fileNames = this.find('.file-names');

		this.fileList = [];

		this.fileItems = [];

	},
	changeHandler: function (event) {
		this.removeClass('is-over');
		this.fileList = this.fileList.concat([...this.formItem.files]);
		this.updateFileList();
	},
	dragEnterHandler: function (event) {
		this.addClass('is-over');
		event.preventDefault();
		event.stopPropagation();
	},
	dragExitHandler: function (event) {
		this.removeClass('is-over');
		event.preventDefault();
		event.stopPropagation();
	},
	dropHandler: function (event) {
		this.removeClass('is-over');
		let dataTransfer = event.dataTransfer;
		this.fileList = this.fileList.concat([...dataTransfer.files]);
		this.updateFileList();
	},
	updateFileList: function () {

		[...this.fileItems].map((elem) => {
			elem.remove();
			return null
		});
		this.fileItems = [];

		let index = 0;
		[...this.fileList].map((file) => {
			let item = Utils.createEl('div.file-names__item');
			item.dataset.index = index;


			item.innerHTML = `<span class="text">${file.name}</span><a class="button button--icon" href="javascript:"><span class="text">Fjern</span><svg class="svg-icon svg-icon--trash"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/svg/symbols.svg#svg-trash">&nbsp;</use></svg></a>`;

			this.fileNames.appendChild(item);
			this.fileItems.push(item);
			index++;

			return null
		});
		[...this.fileItems].map((elem) => {
			let button = Utils.find(elem, '.button')[0];
			Utils.on(button, 'click', this.fileItemDeleteHandler.bind(this));
			return null
		});

	},
	fileItemDeleteHandler: function (event) {
		let item = event.target.closest('.file-names__item');
		Utils.addClass(item, 'is-removing');
		setTimeout(function () {
			let index = Math.floor(item.dataset.index);
			Log.db(index, this.fileList);
			this.fileList.splice(index, 1);
			Utils.removeClass(event.target, 'is-removing');

			this.updateFileList();
		}.bind(this), 220);
	},

	getFileList: function () {
		Log.db(this.fileList);

		return this.fileList;

	}
});


(function () {
	function init() {
		Utils.each(Utils.find('.form'), function (elem) {
			new Forms({ el: elem });
		});
	}
	init();
	window.addEventListener('forms:init', init);


	window.addEventListener('dragover', function (e) {
		e.preventDefault();
	}, false);
	window.addEventListener('drop', function (e) {
		e.preventDefault();
	}, false);
})();


export { Forms, Text }
